export async function loadJsPdf() {
  const { jsPDF } = await import('jspdf');
  return jsPDF;
}

export async function loadReceiptPdfTools() {
  const [jsPDF, html2canvas] = await Promise.all([
    loadJsPdf(),
    import('html2canvas').then((module) => module.default),
  ]);

  return { jsPDF, html2canvas };
}
